<script>
import { counterMixin } from '@mixins/counter-mixin';
import { modalMethods } from '@state/helpers';
export default {
  components: {},
  props: {
    exercise: {
      type: Object,
      required: true,
      default: () => {},
    },
    exerciseIndex: {
      // We'll probably need to view/make actions on the exercise item
      type: Number,
      required: false,
      default: null,
    },
    circuitIndex: {
      // We'll probably need to view/make actions on the exercise item
      type: Number,
      required: false,
      default: null,
    },
  },
  mixins: [counterMixin],
  data() {
    return {
      listOfEquipment: [],
    };
  },
  computed: {
    thumbnail() {
      return this.exercise &&
        this.exercise.mediaAssets &&
        this.exercise.mediaAssets.thumbnailPhoto &&
        this.exercise.mediaAssets.thumbnailPhoto.url
        ? this.exercise.mediaAssets.thumbnailPhoto.url
        : require('@assets/images/placeholders/exercise-small.jpg');
    },
    label() {
      return this.exercise && this.exercise.label;
    },
    equipments() {
      const equipments = [];
      const equipmentsArray = [];
      if (this.exercise && this.exercise.requiredEquipment) {
        if (this.exercise.requiredEquipment.weighted) {
          equipments.push(this.exercise.requiredEquipment.weighted);
        }
        if (this.exercise.requiredEquipment.unweighted.length > 0) {
          this.exercise.requiredEquipment.unweighted.forEach((equipment) => {
            equipments.push(equipment);
          });
        }
      }

      equipments.forEach((equipment) => {
        if (equipment.label.length > 0) {
          equipmentsArray.push(equipment.label)
        }
      });

      const joinedEquipments = equipmentsArray.length > 0 ? equipmentsArray.join(', ') : null;
      return joinedEquipments;
    },
    reps() {
      return this.exercise && this.exercise.setDirections && this.exercise.setDirections.length > 0
        ? this.exercise.setDirections[0].reps === 1
          ? '1 Rep'
          : `${this.exercise.setDirections[0].reps} Reps`
        : '';
    },
    time() {
      let seconds = 0;
      if (this.exercise && this.exercise.setDirections && this.exercise.setDirections.length > 0) {
        seconds = seconds + parseInt(this.exercise.setDirections[0].time);
      }
      if (seconds > 0) {
        const unit = this.timeUnit(parseInt(seconds));
        const time = this.abbreviatedTime(parseInt(seconds));
        return `${time} ${unit}`;
      } else {
        return null;
      }
    },
    weight() {
      let weight = 0;
      if (this.exercise && this.exercise.setDirections && this.exercise.setDirections.length > 0) {
        weight = weight + parseInt(this.exercise.setDirections[0].weight);
      }
      if (weight > 0) {
        return `${weight.toFixed(0)} Lbs`;
      } else {
        return null;
      }
    },
    modalVideo() {
      return this.exercise &&
        this.exercise.mediaAssets &&
        this.exercise.mediaAssets.coverVideo &&
        this.exercise.mediaAssets.coverVideo.url
        ? this.exercise.mediaAssets.coverVideo.url
        : this.defaultModalVideo;
    },
    commaSeperatedListOfEquipment() {
      this.equipmentList();
      if (this.listOfEquipment.length) {
        return this.listOfEquipment.join(', ');
      }
      return null;
    },
  },
  mounted() {},
  methods: {
    ...modalMethods,
    equipmentList() {
      if (this.exercise.requiredEquipment.weighted) {
        this.listOfEquipment.push(this.exercise.requiredEquipment.weighted.label);
      }
      if (this.exercise.requiredEquipment.unweighted.length) {
        this.exercise.requiredEquipment.unweighted.map((equipment) => this.listOfEquipment.push(equipment.label));
      }
    },
    async showModal(src) {
      await this.setSelectedVideo({
        src,
        exerciseName: this.exercise.label,
        numberOfReps: this.exercise.setDirections[0].reps,
        weight: this.exercise.setDirections[0].weight,
        timeOfExercise: this.exercise.setDirections[0].time,
        listOfEquipment: this.commaSeperatedListOfEquipment,
      });
      this.$bvModal.show('video-preview-modal');
    },
  },
};
</script>

<template>
  <div class="card-exercise-horizontal" @click.stop="showModal(modalVideo)">
    <div class="exercise-card-image" :style="`backgroundImage: url(${thumbnail})`">
      <!-- TODO: View below if active exercise
      <div class="exercise-meta" v-if="exerciseActive">
        <h5> 245<small>lbs</small> </h5>
        <h5> 24<small>reps</small> </h5>
      </div> -->
    </div>
    <div class="exercise-card-content">
      <h4 class="card-name">
        {{ label }} <span v-if="equipments">-</span> {{ equipments }}
        <small v-if="true"
          >{{ weight }} <span v-if="reps && weight">•</span> {{ reps }} <span v-if="(time && reps) || (time && weight)">•</span>
          {{ time }}</small
        >
        <!-- TODO: View below if active exercise
        <small v-if="exerciseActive" class="current-time">
          <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.612 7.082h.942c.425 0 .636-.215.636-.637V1.223c0-.414-.21-.625-.636-.637h-.942C1.19.586.976.8.976 1.223v5.222c-.008.422.207.637.636.637zm3.133 0h.942c.421 0 .636-.215.636-.637V1.223c0-.414-.215-.637-.636-.637h-.942c-.426 0-.637.215-.637.637v5.222c0 .422.204.637.637.637z" fill="#4059E1"/></svg>
          00:29
        </small> -->
      </h4>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card-exercise-horizontal {
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: $base-border-radius-md;
  display: flex;
  margin-bottom: 0.8rem;

  &:hover {
    cursor: pointer;
  }

  .exercise-card-image {
    align-items: flex-end;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-bottom-left-radius: $base-border-radius-md;
    border-top-left-radius: $base-border-radius-md;
    display: flex;
    flex: 1;
    height: 9rem;
    justify-content: center;
    padding-bottom: 1rem;
  }

  .exercise-card-content {
    flex: 2;
    padding: 0 2rem;

    @include media('xxl', null) {
      flex: 4;
    }
  }

  .card-name {
    @include calc-font-size(1.6);

    font-family: $secondary-font-family;
    font-weight: bold;
    line-height: 1.6rem;
    margin-bottom: 0;
    text-transform: capitalize;

    small {
      display: block;
      margin-top: 0.8rem;
      opacity: 0.5;
    }

    .current-time {
      color: $color-action;
      font-weight: bold;
      opacity: 1;
    }
  }

  .exercise-meta {
    align-items: center;
    backdrop-filter: blur(2px);
    background: rgba(0, 0, 0, 0.7);
    border-radius: $base-border-radius-md;
    display: flex;
    height: 50%;
    justify-content: space-between;
    max-height: 5.1rem;
    max-width: 9.2rem;
    padding: 1rem;
    padding-bottom: 1.3rem;
    width: 80%;
    h5 {
      color: white;
      text-align: center;
      @include calc-font-size(1.3);
      small {
        align-items: flex-end;
        display: flex;
        display: block;
        font-weight: bold;
        line-height: 0rem;
        margin-top: 2px;
        text-align: center;
        text-transform: capitalize;
        text-transform: uppercase;
        @include calc-font-size(1);
      }
    }
  }
}
</style>
